import { useOutletContext, useParams } from "react-router-dom";

import Forms from "layouts/forms";

// Thin route wrapper — renders the existing Forms screen with the websiteId
// from the WebsiteLayout outlet context.
function FormsRoute() {
  const { websiteId } = useOutletContext();
  const { websitename } = useParams();
  return <Forms websiteId={websiteId} websiteName={websitename} />;
}

export default FormsRoute;
